import React from "react";

const Footer = () => {
  return (
    <footer>
      <p>© 2025 Abhayy. All rights reserved.</p>
      <a
        href="https://github.com/abhayy143"
        style={{ color: "#1da1f2", textDecoration: "none", margin: "0 10px" }}
      >
        GitHub
      </a>
      <a
        href="https://instagram.com/abhayy143"
        style={{ color: "#1da1f2", textDecoration: "none", margin: "0 10px" }}
      >
        Instagram
      </a>
    </footer>
  );
};

export default Footer;
